import { render, staticRenderFns } from "./reportBasic.vue?vue&type=template&id=80dd2346&"
import script from "./reportBasic.vue?vue&type=script&lang=js&"
export * from "./reportBasic.vue?vue&type=script&lang=js&"
import style0 from "./reportBasic.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports